module.exports = __webpack_public_path__ + "assets/img/00096.ad20b188.png";